<template>
  <div class="app">
    <app-header></app-header>
    <app-navigation></app-navigation>

    <transition name="fade">
      <router-view :key="activeOrganization" />
    </transition>

    <app-add-button @click.native="listVisible = !listVisible" v-click-outside="hideList"></app-add-button>
    <app-add-list :visible="listVisible"></app-add-list>
    <!-- Prosto do dodawania -->
    <!-- <app-add-button @click.native="$router.push('/add-invoice')"></app-add-button> -->
  </div>
</template>

<script>
  import ClickOutside from 'vue-click-outside'

  import Header from './layout/Header.vue'
  import Navigation from './layout/Navigation.vue'
  import AddButton from './layout/AddButton.vue'
  import AddList from './layout/AddList.vue'

  export default {
    name: 'App',
    data() {
      return {
        listVisible: false
      }
    },
    computed: {
      activeOrganization() {
        return this.$store.state.user.activeOrganization
      }
    },
    methods: {
      handleSwipe(direction) {
        if (direction == 'swiperight')
          this.$store.commit('showNav')

        if (direction == 'swipeleft')
          this.$store.commit('hideNav')
      },
      hideList() {
        if(this.listVisible)
          this.listVisible = false
      }
    },
    created() {
      // Sprawdzanie czy token nie wygasł
      const expires_in = this.$store.state.user.session.expires_in
      const logged_at = this.$store.state.user.session.logged_at
      const now = new Date().getTime()

      if(!this.$store.getters['user/isLogged']) {
        this.$store.commit('user/setLoginError', {})
        return
      }

      if(now > logged_at + expires_in) {
        this.$store.dispatch('user/logout')
        this.$store.commit('user/setLoginError', {force: true, message: 'Sesja wygasa! Zaloguj się ponownie'})
      }

      this.$store.dispatch('user/watchForTokenExpires')
    },
    metaInfo: {
      titleTemplate: '%s | Toro by Heseya'
    },
    components: {
      appNavigation: Navigation,
      appHeader: Header,
      appAddButton: AddButton,
      appAddList: AddList
    },
    directives: {
      ClickOutside
    }
  }
</script>

<style lang="scss">
  body {
    font-family: $mainFont;
    font-weight: $normal;
    margin: 0;
    background-color: #fff;
    // padding-top: 60px;
    box-sizing: border-box;
    overflow-x: hidden;

    @media screen and (min-width: #{$media-900}) {
      background-color: #fafafa;
    }
  }

  .content {
    width: 100%;
    padding: 16px;
    margin-top: 60px;
    box-sizing: border-box;
    position: relative;

    @media screen and (min-width: #{$media-900}) {
      width: calc(100% - 300px);
      margin-left: auto;
    }
  }

  .box {
    width: 100%;

    @media screen and (min-width: #{$media-900}) {
      width: 100%;
      max-width: 600px;
      box-sizing: border-box;
      margin: 0 auto;
      background-color: #fff;
      padding: 8px;
      border-radius: 16px;
      box-shadow: 2px 2px 6px #0002;
    }

    &--wide {
      @media screen and (min-width: #{$media-1200}) {
        max-width: 900px;
      }
    }

    &--flex-center {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
    }
  }

  a {
    color: $primaryColor;
    text-decoration: none;
    transition: 0.3s;

    &:hover {
      color: darken($primaryColor, 20)
    }
  }

  h1, h2 {
    font-weight: 300;
    font-size: 22px;
    text-align: center;
  }

  h2 {
    font-size: 18px;
  }

  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: lighten($primaryColor, 10);
  }


  .btn {
    all: unset;
    display: block;
    box-sizing: border-box;
    padding: 10px 24px;
    border-radius: 24px;
    background-color: #fff;
    box-shadow: 2px 2px 8px $primaryColor;
    cursor: pointer;
    text-align: center;
    font-family: $mainFont;
    font-weight: $normal;
    color: $primaryColor;
    font-size: 14px;
    transition: 0.3s;

    &:disabled {
      cursor: not-allowed;
      filter: grayscale(0.5);
    }

    &:hover {
      box-shadow: 2px 2px 14px $primaryColor;
    }

    &--icon {
      padding: 10px 12px;
    }

    &--margined {
      margin-top: 16px;
      margin-bottom: 16px;
    }

    &--gradient {
      background: linear-gradient(30deg, $primaryColor, lighten($primaryColor, 10));
      color: #fff;

      &:hover {
        color: #fff;
      }
    }

    &--warn {
      background: linear-gradient(30deg, #ff8f56, lighten(#ff8f56, 10));
      color: #fff;
      box-shadow: 2px 2px 8px #ff8f56;

      &:hover {
        box-shadow: 2px 2px 14px #ff8f56;
      }
    }

    &--small {
      padding: 6px 16px;
      font-size: 0.8em;
    }
  }

  .form-error,
  .form-info {
    display: block;
    color: $errorColor;;
    max-height: 0;
    opacity: 0;
    transition: 0.3s;
    visibility: hidden;
    text-align: center;

    &:not(:empty) {
      max-height: 20px;
      opacity: 1;
      visibility: visible;
      animation: shake 0.3s ease-in-out;
    }
  }

  .form-info {
    color: $primaryColor;
  }

  @keyframes shake {
    $val: 4px;

    0% {
      transform: translateX(-$val)
    }

    33% {
      transform: translateX($val)
    }

    66% {
      transform: translateX(-$val)
    }

    100% {
      transform: translateX(0)
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  .center-button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
  }

  .modal-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &__row {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 0 16px;

      &--2-1 {
        grid-template-columns: 2fr 1fr;
      }
    }
  }

  .content-list {
    width: 100%;
    margin: 12px auto;
    margin-top: 0;

    @media screen and (min-width: #{$media-600}) {
      width: 80%;
    }

    &__item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px;
      border-bottom: solid 1px #eee;

      &:first-of-type {
        border-top: solid 1px #eee;
      }
    }

    &__content {
      margin-right: auto;
    }

    &__title {
      color: #333;
      margin-right: auto;
    }

    &__meta {
      color: #888;
    }

    &__default {
      color: $primaryColor;
      margin-right: 2px;
      font-size: 0.9em;
    }

    &__btn {
      all: unset;
      width: 24px;
      height: 24px;
      cursor: pointer;
      margin-left: 12px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.8em;
      color: #888;
      transition: color 0.3s;

      &:hover {
        color: firebrick;
      }

      &--normal:hover {
        color: $primaryColor;
      }
    }
  }

  .grecaptcha-badge {
    visibility: hidden;
  }

  .recaptcha-alert {
    position: absolute;
    width: 90%;
    bottom: 8px;
    left: 50%;
    transform: translate(-50%);
    color: #888;
    display: block;
    text-align: center;
    font-size: 0.6em;
  }

  .vs-notifications h3 {
    font-weight: 500 !important;
  }
</style>
